import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "app-information",
  templateUrl: "./information.component.html",
  styleUrls: ["./information.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class InformationComponent implements OnInit {
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;

  @Input() name: string;
  @Input() description: string;
  @Input() detail: any;
  @Input() gallery;
  @Input() url;
  public iframeLoaded = false;
  public countImg;

  constructor() {}

  ngOnInit(): void {
    this.countImg = this.gallery.length;
  }
  //   this.scrollToBottom();
  // }

  // ngAfterViewChecked() {
  //   this.scrollToBottom();
  // }

  // scrollToBottom(): void {
  //   try {
  //     this.myScrollContainer.nativeElement.scrollTop =
  //       this.myScrollContainer.nativeElement.scrollHeight * -1;
  //   } catch (err) {}
  // }
}
